enum TearVerticalPosition {
  Top = "Top",
  Bottom = "Bottom",
}

export default TearVerticalPosition
